import { render, staticRenderFns } from "./movie-list.vue?vue&type=template&id=7cfb4489"
import script from "./movie-list.vue?vue&type=script&lang=js"
export * from "./movie-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports